<template>
  <div :class="$style.container" @click="onRedirect">
    <div :class="$style.icon">
      <svg width="100%" height="100%" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <polygon fill-rule="evenodd" clip-rule="evenodd" points="6.414 13 12.707 19.293 11.293 20.707 2.586 12 11.293 3.293 12.707 4.707 6.414 11 21 11 21 13" />
      </svg>
    </div>
    <div :class="$style.title">{{ title }}</div>

    <div :class="$style.right">
      <slot />
    </div>
  </div>
</template>

<script>
export default {
  props: {
    title: {
      type: String,
    },
    historyMode: {
      type: Boolean,
      default: () => false,
    },
    redirect: {
      type: String,
      default: () => '',
    },
  },
  methods: {
    onRedirect() {
      if (this.historyMode) {
        this.$router.go(-1);
        return;
      }

      this.$router.push({ name: this.redirect || 'cabinet' });
    },
  },
};
</script>

<style lang="sass" module>
  .container
    display: flex
    flex-direction: column
    flex-grow: 1
    cursor: pointer

  .icon
    max-width: 20px
    max-height: 20px

    svg
      width: 100%
      display: block
      fill: var(--color-icon-primary)

  .title
    font-weight: 400
    font-size: 20px
    color: #fff
</style>
